/**
 * Created by Victor Rojo on 4/9/17.
 */
import { NgModule }                   from '@angular/core';
import { RouterModule, Routes }       from '@angular/router';

import { LoginComponent }             from "./login/login.component";
import { SignupComponent }            from "./signup/signup.component";
import { ActivateComponent }          from "./activate/activate.component";
import { PasswordRecoveryComponent }  from "./password-recovery/password-recovery.component";
import { PasswordResetComponent }     from "./password-recovery/password-reset.component";
import {TryDemoComponent} from "./try-demo/try-demo.component";

const routes: Routes =  [
  {path: 'login', component: LoginComponent },
  {path: 'signup', component: SignupComponent },
  {path: 'activate', component: ActivateComponent },
  {path: 'password-recovery', component: PasswordRecoveryComponent },
  {path: 'password-reset', component: PasswordResetComponent },
  {path: 'try-demo', component: TryDemoComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule {}
